import { gaEvent, gaEvents } from '@/azure/types';

const EVENT = 'uaevent';
const EVENT_CATEGORY = 'Customer';

const EVENT_ACTIONS = {
  LOGIN: 'Login',
  REGISTRATION: 'Registration',
};

interface DataLayerObject {
  event: string;
  eventCategory: string;
  eventAction: string;
  eventLabel: string;
  eventVariant?: string;
}

export const pushToDataLayer = ({ eventAction, eventLabel, eventVariant }: gaEvent): void => {
  const data = {
    event: EVENT,
    eventCategory: EVENT_CATEGORY,
    eventAction,
    eventLabel,
  } as DataLayerObject;
  if (eventVariant) {
    data.eventVariant = eventVariant;
  }
  window.dataLayer && window.dataLayer.push(data);
};

export const GA_EVENTS: gaEvents = {
  SUCCESSFUL_LOGIN: {
    eventAction: EVENT_ACTIONS.LOGIN,
    eventLabel: 'login attempt succeed',
  },
  UNSUCCESSFUL_LOGIN: {
    eventAction: EVENT_ACTIONS.LOGIN,
    eventLabel: 'login attempt failed',
  },
  OPEN_SIGN_UP: {
    eventAction: EVENT_ACTIONS.REGISTRATION,
    eventLabel: 'open sign-up',
  },
  OPEN_RESET_PASSWORD: {
    eventAction: EVENT_ACTIONS.LOGIN,
    eventLabel: 'reset password',
  },
  SEND_VERIFICATION_CODE_FORGOT_PASSWORD_PAGE: {
    eventAction: EVENT_ACTIONS.LOGIN,
    eventLabel: 'send verification code',
  },
  RESEND_VERIFICATION_CODE_FORGOT_PASSWORD_PAGE: {
    eventAction: EVENT_ACTIONS.LOGIN,
    eventLabel: 're-send verification code',
  },
  SEND_VERIFICATION_CODE_REGISTRATION_PAGE: {
    eventAction: EVENT_ACTIONS.REGISTRATION,
    eventLabel: 'send verification code',
  },
  RESEND_VERIFICATION_CODE_REGISTRATION_PAGE: {
    eventAction: EVENT_ACTIONS.REGISTRATION,
    eventLabel: 're-send verification code',
  },
  SUCCESSFUL_CODE_VERIFICATION: {
    eventAction: EVENT_ACTIONS.REGISTRATION,
    eventLabel: 'successful code verification',
  },
  SUCCESSFUL_ACCOUNT_CREATION: {
    eventAction: EVENT_ACTIONS.REGISTRATION,
    eventLabel: 'account creation succeed',
  },
  UNSUCCESSFUL_ACCOUNT_CREATION: {
    eventAction: EVENT_ACTIONS.REGISTRATION,
    eventLabel: 'account creation failed',
  },
};
